import React from "react";

export const MetricCard = ({ label, value, hint, icon: Icon, accent = false, testId }) => {
  return (
    <div
      className="relative overflow-hidden rounded-lg border border-slate-200 bg-white p-6 transition-shadow duration-300 hover:shadow-md"
      data-testid={testId}
    >
      <div className="flex items-start justify-between">
        <div className="overline">{label}</div>
        {Icon && (
          <div
            className="flex h-9 w-9 items-center justify-center rounded-md"
            style={{ background: accent ? "#D4AF37" : "#F1F5F9" }}
          >
            <Icon className="h-4 w-4" style={{ color: accent ? "#0F172A" : "#334155" }} />
          </div>
        )}
      </div>
      <div className="mt-4 font-display text-3xl font-semibold tracking-tight text-slate-900 font-mono-num">
        {value}
      </div>
      {hint && <div className="mt-2 text-xs text-slate-500 font-mono-num">{hint}</div>}
      {accent && (
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[3px]" style={{ background: "#D4AF37" }} />
      )}
    </div>
  );
};

export default MetricCard;
